import { createLineHeightVariables as r, createFontSizeVariables as o } from "./highrise446.mjs";
const e = {
  fontSize: o("2xl"),
  lineHeight: r("2xl"),
  height: "44px",
  paddingLeft: "14px",
  paddingRight: "14px",
  chevronSize: "20px",
  borderRadius: "8px",
  suffixIconFontSize: "16px",
  paddingVertical: "10px"
}, p = {
  fontSize: o("2xl"),
  lineHeight: r("2xl"),
  height: "40px",
  paddingLeft: "12px",
  paddingRight: "12px",
  chevronSize: "20px",
  borderRadius: "8px",
  suffixIconFontSize: "16px",
  paddingVertical: "10px"
}, x = {
  fontSize: o("lg"),
  lineHeight: r("lg"),
  height: "36px",
  paddingLeft: "8px",
  paddingRight: "8px",
  chevronSize: "16px",
  borderRadius: "6px",
  suffixIconFontSize: "14px",
  paddingVertical: "8px"
}, a = {
  fontSize: o("md"),
  lineHeight: r("md"),
  height: "32px",
  paddingLeft: "8px",
  paddingRight: "8px",
  chevronSize: "14px",
  borderRadius: "4px",
  suffixIconFontSize: "13px",
  paddingVertical: "6px"
}, d = {
  fontSize: o("sm"),
  lineHeight: r("sm"),
  height: "28px",
  paddingLeft: "6px",
  paddingRight: "6px",
  chevronSize: "14px",
  borderRadius: "4px",
  suffixIconFontSize: "12px",
  paddingVertical: "7px"
}, t = {
  fontSize: o("xs"),
  lineHeight: r("xs"),
  height: "24px",
  paddingLeft: "6px",
  paddingRight: "6px",
  chevronSize: "12px",
  borderRadius: "4px",
  suffixIconFontSize: "11px",
  paddingVertical: "6px"
}, l = {
  lg: "16px",
  md: "16px",
  sm: "16px",
  xs: "14px",
  "2xs": "14px",
  "3xs": "12px"
}, s = {
  lg: "20px",
  md: "20px",
  sm: "16px",
  xs: "16px",
  "2xs": "14px",
  "3xs": "14px"
}, g = {
  lg: "18px",
  md: "18px",
  sm: "16px",
  xs: "16px",
  "2xs": "14px",
  "3xs": "14px"
}, c = {
  lg: "4px",
  md: "4px",
  sm: "4px",
  xs: "4px",
  "2xs": "4px",
  "3xs": "2px"
}, u = {
  lg: "18x",
  md: "18px",
  sm: "16px",
  xs: "16px",
  "2xs": "14px",
  "3xs": "12px"
};
function m(i = "md") {
  const n = {
    lg: e,
    md: p,
    sm: x,
    xs: a,
    "2xs": d,
    "3xs": t
  };
  return n[i] || n.md;
}
function C() {
  return {
    bezier: "cubic-bezier(.4, 0, .2, 1)",
    border: "1px solid var(--gray-300)",
    borderRadius: "4px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    borderHover: "1px solid var(--primary-600)",
    borderFocus: "1px solid var(--primary-600)",
    boxShadowFocus: "0px 0px 0px 4px #D1E0FF, 0px 1px 2px 0px #1018280D",
    textColorDisabled: "var(--gray-400)",
    placeholderColor: "var(--gray-500)",
    placeholderColorDisabled: "var(--gray-400)",
    backgroundColor: "var(--white)",
    caretColor: "var(--primary-500)",
    loadingColor: "var(--primary-300)",
    iconGap: "4px",
    iconColor: "var(--gray-400)",
    colorDisabled: "var(--gray-50)",
    borderDisabled: "1px solid var(--gray-300)",
    iconColorDisabled: "var(--gray-300)",
    caretColorWarning: "#f0a020",
    loadingColorWarning: "#f0a020",
    caretColorError: "#d03050",
    boxShadowFocusError: "0px 0px 0px 4px var(--error-100), 0px 1px 2px 0px #1018280D",
    borderError: "1px solid var(--error-300)",
    borderFocusError: "1px solid var(--error-300)",
    borderHoverError: "1px solid var(--error-300)",
    loadingColorError: "#d03050",
    textColorError: "var(--error-300)",
    textColorWarning: "var(--warning-300)"
  };
}
function y(i = "md") {
  return {
    suffixIconSize: l[i],
    prefixIconSize: s[i],
    inlineCTAIconSize: g[i],
    dropdownIconBackgroundRadius: c[i],
    dropdownIconBackgroundSize: u[i]
  };
}
function R() {
  return {
    tooltipBorderRadius: "4px",
    tooltipPadding: "8px"
  };
}
const F = {
  boxShadow: "none",
  border: "none",
  borderHover: "none",
  borderFocus: "1px solid var(--primary-200)",
  boxShadowFocus: "none",
  borderRadius: "4px",
  iconGap: "4px",
  iconColor: "var(--gray-400)",
  bezier: "cubic-bezier(.4, 0, .2, 1)",
  textColor: "var(--gray-900)",
  textColorHover: "var(--gray-900)",
  textColorDisabled: "var(--gray-500)",
  placeholderColor: "var(--gray-500)",
  placeholderColorDisabled: "var(--gray-500)",
  backgroundColor: "var(--white)",
  caretColor: "var(--primary-500)",
  loadingColor: "var(--primary-300)",
  colorDisabled: "transparent",
  borderDisabled: "transparent",
  iconColorDisabled: "var(--gray-300)",
  backgroundColorDisabled: "transparent",
  backgroundColorHoverDisabled: "transparent",
  caretColorWarning: "#f0a020",
  boxShadowFocusWarning: "none",
  boxShadowFocusError: "none",
  borderWarning: "1px solid var(--warning-400)",
  borderFocusWarning: "1px solid var(--warning-400)",
  borderError: "1px solid var(--error-400)",
  borderFocusError: "1px solid var(--error-400)",
  loadingColorWarning: "#f0a020",
  caretColorError: "#d03050",
  loadingColorError: "#d03050",
  suffixIconColor: "var(--n-icon-color)",
  prefixIconColor: "var(--n-icon-color)"
}, h = {
  fontSize: o("2xl"),
  lineHeight: r("2xl"),
  height: "40px",
  paddingLeft: "6px",
  paddingRight: "6px",
  chevronSize: "20px",
  borderRadius: "4px",
  suffixIconFontSize: "16px",
  paddingVertical: "10px",
  iconGap: "4px"
}, f = {
  fontSize: o("2xl"),
  lineHeight: r("2xl"),
  height: "36px",
  paddingLeft: "6px",
  paddingRight: "6px",
  chevronSize: "20px",
  borderRadius: "4px",
  suffixIconFontSize: "16px",
  paddingVertical: "10px",
  iconGap: "4px"
}, S = {
  fontSize: o("lg"),
  lineHeight: r("lg"),
  height: "28px",
  paddingLeft: "4px",
  paddingRight: "4px",
  chevronSize: "16px",
  borderRadius: "4px",
  suffixIconFontSize: "14px",
  paddingVertical: "8px",
  iconGap: "4px"
}, b = {
  fontSize: o("md"),
  lineHeight: r("md"),
  height: "26px",
  paddingLeft: "4px",
  paddingRight: "4px",
  chevronSize: "14px",
  borderRadius: "4px",
  suffixIconFontSize: "13px",
  paddingVertical: "6px",
  iconGap: "2px"
}, v = {
  fontSize: o("sm"),
  lineHeight: r("sm"),
  height: "21px",
  paddingLeft: "2px",
  paddingRight: "2px",
  chevronSize: "14px",
  borderRadius: "4px",
  suffixIconFontSize: "12px",
  paddingVertical: "7px",
  iconGap: "2px"
}, z = {
  fontSize: o("xs"),
  lineHeight: r("xs"),
  height: "20px",
  paddingLeft: "2px",
  paddingRight: "2px",
  chevronSize: "12px",
  borderRadius: "4px",
  suffixIconFontSize: "11px",
  paddingVertical: "6px",
  iconGap: "2px"
};
function H(i = "md") {
  const n = {
    lg: h,
    md: f,
    sm: S,
    xs: b,
    "2xs": v,
    "3xs": z
  };
  return n[i] || n.md;
}
function w(i = "left") {
  return {
    inputTextAlign: i
  };
}
export {
  y as IconSizeStyles,
  C as commonInputStyles,
  H as createInlineInputSizeStyle,
  m as createInputSizeStyle,
  R as getTooltipStyles,
  F as inlineInputStyles,
  w as inputTextAlignStyles
};
